import DOMPurify from 'dompurify';
import showdown from 'showdown';

const converter = new showdown.Converter();

/**
 * Sanitizes HTML string to prevent XSS attacks
 * @param {string} html - Raw HTML string
 * @returns {string} Sanitized HTML string
 */
export const sanitizeHtml = (html) => DOMPurify.sanitize(html);

/**
 * Converts markdown to sanitized HTML
 * @param {string} markdown - Markdown string
 * @returns {string} Sanitized HTML string
 */
export const markdownToSafeHtml = (markdown) => {
  const html = converter.makeHtml(markdown || '');
  return DOMPurify.sanitize(html);
};

/**
 * Converts markdown to sanitized HTML, stripping paragraph tags
 * @param {string} markdown - Markdown string
 * @returns {string} Sanitized HTML string without wrapping p tags
 */
export const markdownToSafeHtmlInline = (markdown) => {
  const html = converter.makeHtml(markdown || '').replace(/^<p>|<\/p>$/g, '');
  return DOMPurify.sanitize(html);
};
